import { CurrencyInput, DocumentNumberField, FormField } from '@/components/custom/erp';
import { QuyenChungTu } from '@/types/schemas';
import { Label } from '@/components/ui/label';
import { MA_CHUNG_TU } from '@/constants';
import { FormMode } from '@/types/form';

interface BasicInfoTabProps {
  formMode: FormMode;
  quyenChungTu: QuyenChungTu | null;
  setQuyenChungTu: (quyenChungTu: QuyenChungTu) => void;
  soChungTu: string;
  setSoChungTu: (soChungTu: string) => void;
}

export const BasicInfoTab: React.FC<BasicInfoTabProps> = ({
  formMode,
  quyenChungTu,
  setQuyenChungTu,
  soChungTu,
  setSoChungTu
}) => {
  return (
    <div className='space-y-2 p-4'>
      <div className='grid grid-cols-4 gap-4 space-y-1'>
        <div className='col-span-3'>
          <DocumentNumberField
            ma_ct={MA_CHUNG_TU.TONG_HOP.PHIEU_KE_TOAN_THEO_NGHIEP_VU}
            quyenChungTu={quyenChungTu}
            onQuyenChungTuChange={setQuyenChungTu}
            soChungTu={soChungTu}
            onSoChungTuChange={setSoChungTu}
            disabled={formMode === 'view'}
            formMode={formMode}
          />

          <div className='flex items-center'>
            <Label className='w-32 min-w-32'>Ngày chứng từ</Label>
            <div className='w-[200px]'>
              <FormField type='date' name='ngay_ct' disabled={formMode === 'view'} />
            </div>
          </div>

          <div className='flex items-center'>
            <Label className='w-32 min-w-32'>Diễn giải</Label>
            <div className='w-full'>
              <FormField type='text' name='dien_giai' disabled={formMode === 'view'} />
            </div>
          </div>
        </div>

        <div className='col-span-1'>
          <CurrencyInput formMode={formMode} labelClassName='w-32 min-w-32' classNameInput='w-full' />

          <div className='flex items-center'>
            <Label className='w-32 min-w-32'>Trạng thái</Label>
            <div className='w-[285px]'>
              <FormField
                type='select'
                name='status'
                options={[
                  { value: '0', label: 'Chưa ghi sổ' },
                  { value: '3', label: 'Chờ duyệt' },
                  { value: '5', label: 'Đã ghi sổ' }
                ]}
                disabled={formMode === 'view'}
              />
            </div>
          </div>

          <div className='flex items-center pt-2'>
            <Label className='w-32 min-w-32'></Label>
            <FormField type='checkbox' name='transfer_yn' label='Dữ liệu được nhận' disabled={true} />
          </div>
        </div>
      </div>
    </div>
  );
};
